import { render, staticRenderFns } from "./Patients.vue?vue&type=template&id=406e9ea1&"
import script from "./Patients.vue?vue&type=script&lang=ts&"
export * from "./Patients.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports